import React from "react";
import "./PrincipalMessagePage.css";

import {
    FaFacebookF,
    FaTwitter,
    FaEnvelope,
    FaQuoteLeft,
    FaGraduationCap
} from "react-icons/fa";

import { motion } from "framer-motion";

import principalImage from "./mama.jpg";

import Footer from "./Footer";


const PrincipalMessagePage = () => {


return (

<div>


<section className="principal-page">


<div className="principal-background-circle circle-one"></div>
<div className="principal-background-circle circle-two"></div>



<div className="principal-wrapper">



{/* Principal Image Section */}


<motion.div

className="principal-profile"

initial={{
opacity:0,
x:-80
}}

whileInView={{
opacity:1,
x:0
}}

transition={{
duration:.8
}}

viewport={{
once:true
}}

>


<div className="principal-image-box">


<img

src={principalImage}

alt="Principal"

className="principal-image"

/>



<div className="principal-role">

<FaGraduationCap />

Principal & Founder

</div>


</div>




<div className="principal-details">


<h3>

Message From Our Principal
</h3>


<p>

Message From Our Principal
</p>


<div className="social-icons">


<a href="#">
<FaFacebookF/>
</a>


<a href="mailto:principal@school.com">
<FaEnvelope/>
</a>


<a href="#">
<FaTwitter/>
</a>


</div>



</div>



</motion.div>







{/* Message Section */}


<motion.div


className="principal-message-card"


initial={{
opacity:0,
x:80
}}


whileInView={{
opacity:1,
x:0
}}


transition={{
duration:.8
}}


viewport={{
once:true
}}

>


<div className="quote-icon">

<FaQuoteLeft/>

</div>



<h2>
Message From Our Principal
</h2>



<p>


Welcome to our esteemed school, a place where young minds are nurtured to achieve their highest potential.


As the principal, I take immense pride in the dedication of our faculty, the enthusiasm of our students, and the unwavering support from our parents and community.


Our mission is to provide a balanced education that focuses not only on academic excellence but also on character building, creativity, and leadership.


We believe every student is unique and deserves the opportunity to shine. Through innovation, discipline, and compassion, we prepare our learners for future success.


Together, we create an environment where students develop confidence, integrity, and lifelong learning skills.


I invite you to join us on this journey of excellence, growth, and achievement.


</p>



<div className="principal-signature">

Message From Our Principal
<span>
Principal
</span>

</div>



</motion.div>



</div>


</section>


<Footer/>


</div>


);

};


export default PrincipalMessagePage;